export default __webpack_public_path__ + "static/media/hotel-resort-img-14.72f5607c.jpg";